import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Country } from '@shared/models/country';
import { loadCountries } from '../actions/load-countries.actions';
import * as fromCountries from '../reducers/countries.reducer';
import { selectCountry } from '../actions/select-country.actions';
import { LoadingState } from '@shared/types/loading-state';
import { TradingEntity } from '@shared/types/trading-entity';
import { GroupType } from '@shared/types/group-type';

@Injectable({
  providedIn: 'root',
})
export class CountriesService {
  constructor(private store: Store) {}

  loadCountries() {
    this.store.dispatch(loadCountries());
  }

  selectCountry(countryAlpha2Code: string) {
    this.store.dispatch(selectCountry({ countryAlpha2Code: countryAlpha2Code }));
  }

  getCountriesLoadingState(): Observable<LoadingState> {
    return this.store.select(fromCountries.selectCountriesLoadingState);
  }

  getCountries(): Observable<Country[]> {
    return this.store.select(fromCountries.selectAvailableCountries);
  }

  getAllCountries(): Observable<Country[]> {
    return this.store.select(fromCountries.selectAllCountries);
  }

  getCountriesByTradingEntityAndGroupType(tradingEntity: TradingEntity, groupType: GroupType): Observable<Country[]> {
    return this.store.select(fromCountries.selectCountriesByTradingEntityAndGroupType(tradingEntity, groupType));
  }

  getSelectedCountry(): Observable<Country | undefined> {
    return this.store.select(fromCountries.selectSelectedCountry);
  }

  getSelectedCountryByAlpha2Code(alpha2_code: string): Observable<Country | undefined> {
    return this.store.select(fromCountries.selectCountryByAlpha2Code(alpha2_code));
  }
}
